module.exports = __webpack_public_path__ + "static/media/ope_marjo_768x960.5516f0ca.jpg";